import cn from "classnames"

import styles from "./ComponentLabel.module.scss"

import type { ComponentLabelType } from "."

export const ComponentLabel: ComponentLabelType = ({ children, className }) => (
  <div className={cn(styles.label, className)} data-tooltip-show-more="true">
    {children}
  </div>
)
